
import React, { useState, useEffect } from 'react';
import { SupportedLanguage } from '@/types/language';

export const useLanguageManager = () => {
  // Default to zh-TW or use the stored language preference
  const [language, setLanguage] = useState<SupportedLanguage>('zh-TW');

  useEffect(() => {
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage && ['en', 'zh-TW'].includes(savedLanguage)) {
      setLanguage(savedLanguage as SupportedLanguage);
    }
  }, []);

  const handleSetLanguage = (newLanguage: SupportedLanguage) => {
    setLanguage(newLanguage);
    localStorage.setItem('language', newLanguage);
    
    // Apply language preference immediately
    document.documentElement.setAttribute('lang', newLanguage);
  };

  return {
    language,
    setLanguage: handleSetLanguage,
  };
};
